import React, { useState } from "react";
import { formatAmount, renderStatus } from "../../../utils/helper";
import { useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../index.scss";
import { getFilteredDataWithTabs } from "../../../service/commonService";
import { setTransactionData } from "../../../store/slices/orders/ordersSlice";
import { CardBody } from "react-bootstrap";

const Transaction = ({code}) => {
  const [sortColumn, setSortColumn] = useState("created_date");
  const [sortOrder, setSortOrder] = useState("DESC");
  const rowsPerPage = useSelector((state) => state.common.pagination.size);
  const pageNumber = useSelector((state) => state.common.pagination.page);
  const transactionData = useSelector((state) => state.orders.transactionData);

  useEffect(() => {
    if (code) {
        const params = {
          page: pageNumber,
          size: rowsPerPage,
          listEntityType: "ODRT",
          sortColumn: sortColumn,
          sordOrder: sortOrder.toUpperCase(),
          parentId: code,
          parentType: "ODR"
        };
    
        getFilteredDataWithTabs("PMT", setTransactionData, {}, params);
    }
  }, [code]);

  const columns = [
    {
      name: "Transaction ID",
      selector: (row) => row?.txn_id,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => formatAmount(row.amount) || "-",
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.created_date || "-",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => renderStatus(row.payment_status) || "-",
      sortable: true,
    }
  ];
  return (
    <CardBody className="order--detail--table">
      <DataTable
        columns={columns}
        data={transactionData}
        customStyles={{
          headCells: {
            style: {
              fontWeight: "bold",
              backgroundColor: "#F3F6F9",
            },
          },
        }}
        pagination
      />
    </CardBody>
  );
};

export default Transaction;
